import React from "react";
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const FooterCategoryItem = ({ category, to }) => {
  return (
    <Link to={to} className="footer-category-item">
      <h6>{category}</h6>
      <span>
        <Icon.ChevronRight />
      </span>
    </Link>
  );
};

export default FooterCategoryItem;
